import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { submitForm } from '../../api/forms.api';
import DynamicForm from '../DynamicForm/DynamicForm';
import { FormsProps } from '../../types/forms';
import { useMessage } from '../../hooks/useMessage';

const DataEntryForm = ({ formId, formAllFields, skin }: FormsProps) => {
    const { showMessage, MessageContainer } = useMessage();
    const [ submitting, setSubmitting ] = useState(false);

    const submitFormHandler = async (values: {
        [key: string]: any
    }) => {
        if (!formId) {
            return;
        }

        const formData: {
            form_id: number;
            data: {
                id: string;
                value: any;
            }[];
        } = {
            form_id: +formId,
            data: [],
        };

        Object.keys(values).forEach((key: string) => {
            formData.data.push({ id: key, value: values[key] });
        });

        setSubmitting(true);
        submitForm(formData)
        .then(() => {
            setSubmitting(false);
            showMessage('Your data has been saved!', 'success');
        })
        .finally(() => setSubmitting(false));
    };

    return (
        <div style={{ margin: 16 }}>
            <div>
                {skin === 'skin1' && (
                    <>
                        <Typography variant="h4" gutterBottom>Fill in the form</Typography>
                        <h4 style={{ margin: '8px auto 16px' }}>
                            Please fill in the data.
                        </h4>
                    </>
                )}
            </div>
            <DynamicForm
                config={{ fields: formAllFields.filter(item => !item.hidden) }}
                onSubmit={submitFormHandler}
                apiSubmitting={submitting}
                skin={skin}
            />
            <MessageContainer/>
        </div>
    );
};

export default DataEntryForm;